import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { TimeOffRequestBlackoutPeriod } from '@models/time-off-v3/time-off-request-blackout-period.model';
import { AppDatePipe } from '@app/pipes';

const appDate = new AppDatePipe();

export class DateRange extends Column {
    title = 'time-off-v3.blackoutDateRange';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(blackoutPeriod: TimeOffRequestBlackoutPeriod): string | null {
        const formattedStartDate = appDate.transform(blackoutPeriod.startDate, 'EE , d LLLL, yyyy');
        const formattedEndDate = appDate.transform(blackoutPeriod.endDate, 'EE , d LLLL, yyyy');

        return `${formattedStartDate} - ${formattedEndDate}`;
    }
}
